import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Grid, Typography ,  } from "@mui/material";
import { Person } from "@mui/icons-material";
import {useMapsLibrary } from '@vis.gl/react-google-maps';
import moment from 'moment-timezone';
import Carousel from 'react-material-ui-carousel'
import { CUSTOM_CONSTANTS } from "Constants";

// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

//Services
import DispatcherApi from "Services/Dispatcher";

const Estimatedcarousel = ({ distance , duration ,  services , 
  timezone , setTravelduration , activecarouselRef}) => {
    const classes = useStyles();
    const navigate = useNavigate();

const traveldistance = parseFloat(distance?.replace("km", "").trim()); 
 // Parse travel duration (e.g., "4 hours 9 mins")
 const durationParts = duration?.match(/(\d+)\s*hours?|\d+\s*mins?/g);
 let travelduration = 0;

 if (durationParts) {
   for (const part of durationParts) {
     if (part.includes("hour")) {
      travelduration += parseInt(part) * 60; // Convert hours to minutes
     } else if (part.includes("min")) {
      travelduration += parseInt(part); // Add minutes directly
     }
   }
 }

 setTravelduration(travelduration);
//console.log('travelduration--->',travelduration);
//console.log('traveldistance--->',traveldistance);


 // //console.log('services--->',services);
const serviceFares = services?.map((service) => {
  // Extract properties directly from service
  const { fareDetails , serviceName, serviceImage, 
    serviceImageDecription, seatsAvailable, serviceDescritpion, 
    _id, ...otherServiceData 
  } = service;

//console.log('servicefaremodel-->',fareDetails);

// Calculate the base fare based on distance
//console.log('distance-->',traveldistance) 
//console.log('fareDetails.daytime.unitPrice-->',fareDetails.daytime.unitPrice);
const distanceprice = fareDetails.daytime.unitPrice * traveldistance;
//console.log('distanceprice-->',distanceprice);
// Calculate the base fare based on time
//console.log('minutes-->',travelduration) 
//console.log('fareDetails.daytime.minutePrice-->',fareDetails.daytime.minutePrice);
const timeprice = fareDetails.daytime.minutePrice * travelduration;
//console.log('timeprice-->',timeprice);  
// get 5% from fixed distanceprice
const fivepercentofdistance =  (distanceprice * 5) / 100;
// get 5% from fixed timeprice
const fivepercentoftime =  (timeprice * 5) / 100;
//console.log("5% datas-->",fivepercentofdistance+fivepercentoftime)
// sum all with base price 
const totalfare = distanceprice + timeprice + 
fivepercentofdistance + fivepercentoftime + fareDetails.daytime.basePrice
// Estimated fare including VAT
const estimated_fare = parseFloat((totalfare).toFixed(2));

//console.log('estimated_fare-->',estimated_fare);

const currentTime = moment.tz(timezone);
//console.log('Current Time in Target Timezone:', currentTime.format('YYYY-MM-DD HH:mm:ss'));

// Calculate the drop-off time by adding the travel duration
const dropOffTime = currentTime.clone().add(travelduration, 'minutes');

// Format the drop-off time (e.g., "2024-12-27 10:30 AM")
const dropOffTimeFormatted = dropOffTime.format('hh:mm A'); // 12-hour format with AM/PM // 12-hour format with AM/PM

//console.log('Drop-off Time in Target Timezone:', dropOffTimeFormatted);

  // Return the updated service object without serviceName and with service_name
  return {
    ...otherServiceData,
    service_id: _id,
    description: serviceDescritpion,
    service_image: serviceImage,
    service_image_description: serviceImageDecription,
    seats_available: seatsAvailable,
    service_name: serviceName,
    drop_off_time: dropOffTimeFormatted,
    estimated_fare,
    distance
  };
});

if(serviceFares?.length > 0){
activecarouselRef.current=serviceFares[0];
}

    return (
<>
  <Carousel  className={classes.estimatedcarousel}
navButtonsProps={{         
style: {
    backgroundColor: '#262626',
    borderRadius: 63,
    width:"20px",
    height: "20px"
}
}} 
navButtonsWrapperProps={{  
style: {
    bottom: '0',
    top: 'unset'
}
}} 

  autoPlay={false} // Stops auto slide change
  navButtonsAlwaysVisible={true} // Shows next and previous buttons
  indicators={false}
 onChange={(now, previous) => {activecarouselRef.current=serviceFares[now]}}
  >
    {serviceFares?.map((service, index) => (
  <Grid container spacing={2} className={classes.Carouselcontainer}  key={index} >
  <Grid item xs={6} className={classes.Carouselgrids} >
      <img
        src={service?.service_image}
        alt={service?.service_name}
        className={classes.carouselimages}
        loading="lazy"
      />
  </Grid>
  <Grid item xs={6} >
  <Typography variant="body1" className={classes.Carouselcontent}>
  <strong>Drop off : </strong>{service?.drop_off_time ? service?.drop_off_time : "loading..."}
  </Typography>
  <Typography variant="body1" className={classes.Carouselcontent}>
  <strong>Estimated amount : </strong>  {service?.estimated_fare ? 
  service?.estimated_fare +CUSTOM_CONSTANTS.BASE_CURRENCY: CUSTOM_CONSTANTS.BASE_CURRENCY }
  </Typography>
  <Typography variant="body1" className={classes.Carouselcontent}>
  <strong>{service?.service_name}</strong> <Person /> {service?.seats_available}
  </Typography>
  </Grid>
</Grid>
))}
  </Carousel>
</>
);
};

export default Estimatedcarousel;